@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.wintermar.inspection.feature.domain.service

import com.wintermar.inspection.core.ui.component.image.util.FileChunkModel
import com.wintermar.inspection.core.ui.component.image.util.FileModel

data class UploadTask(
    val questionId: String,
    val files: List<FileModel>,
    val callback: ChunkUploadCallback
)

interface ChunkUploadCallback {
    fun onDoneGenerateChunk(questionId: String, fileIds: List<String>)
    fun onProgress(questionId: String, chunk: FileChunkModel)
    fun onCompleted(questionId: String, fileId: String, chunk: FileChunkModel?)
    fun onError(questionId: String, fileId: String, error: Throwable?)
}

expect class ChunkUploadService() {
    fun enqueue(task: UploadTask)
    /**
     * Re-attaches a callback to an already-running upload job identified by [fileId].
     * Call this when the UI re-enters the page so progress events are routed to the new ViewModel.
     */
    fun reattach(questionId: String, fileId: String, callback: ChunkUploadCallback)
    fun cancel(fileId: String? = null)
}
